module.exports = __webpack_public_path__ + "static/icons/icon-airport-transfers-b387bb7aaa8576615723e81fb95e767f.svg";